var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider"},[_c('div',{on:{"click":function($event){return _vm.onSex('male')}}},[_vm._v(" 男 ")]),_c('div',{on:{"click":function($event){return _vm.onSex('female')}}},[_vm._v(" 女 ")]),_c('span',{class:{
      'float-label': true,
      'fe-male': _vm.value === 'male',
      'male-fe': _vm.value === 'female',
    }},[_vm._v(" "+_vm._s(_vm.value === 'male' ? '男' : '女')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }